import type { IAPI } from "../APIService";
import { CategoriesService, type ICategoriesService } from "./Categories";
import { ContextService, type IContextService } from "./Context";
import { CoursesService, type ICoursesService } from "./Courses";
import { type IItemsService, ItemsService } from "./Items";
import { type IMenusService, MenusService } from "./Menus";
import { type IModifierSetsService, ModifierSetsService } from "./ModifierSets";
import { type IModifiersService, ModifiersService } from "./Modifiers";
import { type ISalesLimitsService, SalesLimitsService } from "./SalesLimits";

export interface IOperationsService {
  menus: IMenusService;
  categories: ICategoriesService;
  items: IItemsService;
  salesLimits: ISalesLimitsService;
  modifiers: IModifiersService;
  modifierSets: IModifierSetsService;
  context: IContextService;
  courses: ICoursesService;
}

export class OperationsService implements IOperationsService {
  menus: IMenusService;
  categories: ICategoriesService;
  items: IItemsService;
  salesLimits: ISalesLimitsService;
  modifiers: IModifiersService;
  modifierSets: IModifierSetsService;
  context: IContextService;
  courses: ICoursesService;
  api: IAPI;

  constructor(api) {
    this.api = api;
    this.menus = new MenusService(api);
    this.categories = new CategoriesService(api);
    this.items = new ItemsService(api);
    this.salesLimits = new SalesLimitsService(api);
    this.modifiers = new ModifiersService(api);
    this.modifierSets = new ModifierSetsService(api);
    this.context = new ContextService(api);
    this.courses = new CoursesService(api);
  }
}
